export default __webpack_public_path__ + "static/illustration-your-path-to-college-8f44c4a3f1e2f4c4f6862fde4a2048ab.svg";